import { render, staticRenderFns } from "./ImageGalleryDialog.vue?vue&type=template&id=62f10538&scoped=true"
import script from "./ImageGalleryDialog.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImageGalleryDialog.vue?vue&type=style&index=0&id=62f10538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f10538",
  null
  
)

export default component.exports